/**
 * @generated SignedSource<<65aa7be3f15de82b01097606a7e21db6>>
 * @relayHash 5280af28c05e5086b2506f208acd3df7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ab08f91fc854662b37ea7c90a0446481f4db0647b885ac031ff6b6e2d5dbf436

import type { ConcreteRequest, Query } from 'relay-runtime';
export type DatabaseContainerQuery$variables = {
  contentId: string;
  contentVersion: number;
  spaceKey?: string | null | undefined;
};
export type DatabaseContainerQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly ancestors: ReadonlyArray<{
        readonly id: string | null | undefined;
        readonly status: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly hasInheritedRestrictions: boolean;
      readonly hasRestrictions: boolean;
      readonly hasViewRestrictions: boolean;
      readonly id: string | null | undefined;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly referenceId: string | null | undefined;
      readonly space: {
        readonly alias: string | null | undefined;
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
        readonly name: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
      readonly status: string | null | undefined;
      readonly title: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly dataSecurityPolicy: {
    readonly isActionEnabledForContent: {
      readonly allowed: boolean | null | undefined;
    };
  } | null | undefined;
  readonly spaces: {
    readonly nodes: ReadonlyArray<{
      readonly homepage: {
        readonly id: string | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly name: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly user: {
    readonly confluence: {
      readonly space: {
        readonly id: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly displayName: string | null | undefined;
    readonly emails: ReadonlyArray<{
      readonly isPrimary: boolean | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly id: string | null | undefined;
    readonly locale: string | null | undefined;
    readonly photos: ReadonlyArray<{
      readonly isPrimary: boolean | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type DatabaseContainerQuery = {
  response: DatabaseContainerQuery$data;
  variables: DatabaseContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentVersion"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "title"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "type"
},
v7 = {
  "kind": "ScalarField",
  "name": "status"
},
v8 = {
  "kind": "Variable",
  "name": "spaceKey",
  "variableName": "spaceKey"
},
v9 = [
  (v3/*: any*/)
],
v10 = [
  {
    "kind": "ScalarField",
    "name": "value"
  },
  {
    "kind": "ScalarField",
    "name": "isPrimary"
  }
],
v11 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "referenceId"
          },
          (v4/*: any*/),
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "hasRestrictions"
          },
          {
            "kind": "ScalarField",
            "name": "hasViewRestrictions"
          },
          {
            "kind": "ScalarField",
            "name": "hasInheritedRestrictions"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              },
              (v6/*: any*/),
              {
                "kind": "ScalarField",
                "name": "alias"
              }
            ]
          },
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "ancestors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v6/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      },
      (v8/*: any*/)
    ],
    "concreteType": "PaginatedSpaceList",
    "kind": "LinkedField",
    "name": "spaces",
    "plural": false,
    "selections": [
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "homepage",
            "plural": false,
            "selections": (v9/*: any*/)
          }
        ]
      }
    ]
  },
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "name": "displayName"
      },
      {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": (v10/*: any*/)
      },
      {
        "concreteType": "AtlassianUserEmail",
        "kind": "LinkedField",
        "name": "emails",
        "plural": true,
        "selections": (v10/*: any*/)
      },
      {
        "kind": "ScalarField",
        "name": "locale"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": (v9/*: any*/)
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  },
  {
    "concreteType": "Confluence_dataSecurityPolicy",
    "kind": "LinkedField",
    "name": "dataSecurityPolicy",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Literal",
            "name": "action",
            "value": "PAGE_EXPORT"
          },
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Literal",
            "name": "contentStatus",
            "value": "CURRENT"
          },
          {
            "kind": "Variable",
            "name": "contentVersion",
            "variableName": "contentVersion"
          },
          (v8/*: any*/)
        ],
        "concreteType": "DataSecurityPolicyDecision",
        "kind": "LinkedField",
        "name": "isActionEnabledForContent",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "allowed"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DatabaseContainerQuery",
    "selections": (v11/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "DatabaseContainerQuery",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "5280af28c05e5086b2506f208acd3df7",
    "id": "ab08f91fc854662b37ea7c90a0446481f4db0647b885ac031ff6b6e2d5dbf436",
    "metadata": {},
    "name": "DatabaseContainerQuery",
    "operationKind": "query",
    "text": "query DatabaseContainerQuery($contentId:ID!,$spaceKey:String,$contentVersion:Int!){content(id:$contentId){nodes{id,referenceId,title,operations{operation,targetType},hasRestrictions,hasViewRestrictions,hasInheritedRestrictions,space{id,name,key,type,alias},type,status,ancestors{id,type,title,status}}},spaces(spaceKey:$spaceKey,first:10){nodes{id,name,homepage{id}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary},emails{value,isPrimary},locale,confluence{space{id}}},dataSecurityPolicy{isActionEnabledForContent(action:PAGE_EXPORT,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed}}}"
  }
};
})();

(node as any).hash = "43ce9fc0bb0bb2c56caed04536425170";

export default node;
